import { Component, Input, OnInit } from '@angular/core';
import { SupplierRecordValidationViewModel } from '../view-models/suppliers-record-validation-view-model';
import { TableColumn } from '../../../../../shared-components/custom-table/custom-table.types';
import { TranslateService } from '../../../../../services/translate/translate.service';
import { html } from '../../../../../utils/html-tag-utils';

@Component({
	selector: 'eif-suppliers-upload-validation-result',
	templateUrl: './suppliers-upload-validation-result.component.html',
	styleUrls: ['../upload-suppliers.scss'],
	standalone: false,
})
export class SuppliersUploadValidationResultComponent implements OnInit {
	@Input() validationResultRecords: SupplierRecordValidationViewModel[] = [];
	@Input() showColumnActiveAutomaticFundingRequest: boolean = false;

	public isTableLoading = false;
	public tableColumns: TableColumn[] = [];

	constructor(private translateService: TranslateService) {}

	ngOnInit() {
		this.initializeTableColumns();
	}

	private initializeTableColumns() {
		this.tableColumns = [
			{
				field: 'ValidationStatus',
				header: 'supplier-upload-step3.ValidationStatus',
				align: 'center',
				render: (row: SupplierRecordValidationViewModel) => {
					const status = row.ValidationStatus || '';
					return html`<span class="tag upload-doc-state-${status}">
						${this.translateService.translate(status, 'list-uploadedSupplierRecordState')}
					</span>`;
				},
			},
			{
				field: 'BuyerVatNumber',
				header: 'supplier-upload-step3.SupplierRecordsBuyerVatNumber',
				render: (row: SupplierRecordValidationViewModel) => {
					return `${row.BuyerCountryCode || ''}${row.BuyerVatNumber || ''}`;
				},
			},
			{
				field: 'BuyerManagerName',
				header: 'supplier-upload-step3.SupplierRecordsBuyerManagerName',
				render: (row: SupplierRecordValidationViewModel) => {
					return html`<div>
						<p class="text-truncate max-100">${row.BuyerManagerName || ''}</p>
						<p class="text-truncate max-100">${row.BuyerManagerUsername || ''}</p>
					</div>`;
				},
			},
			{
				field: 'Supplier',
				header: 'supplier-upload-step3.SupplierRecordsSupplier',
				render: (row: SupplierRecordValidationViewModel) => {
					return html`<div>
						<p class="text-truncate is-w-supplier">${row.SupplierName || ''}</p>
						<div>${row.SupplierCountryCode || ''}${row.SupplierVatNumber || ''}</div>
					</div>`;
				},
			},
			{
				field: 'SupplierLanguageCode',
				header: 'supplier-upload-step3.SupplierRecordsSupplierLanguageCode',
				render: (row: SupplierRecordValidationViewModel) => {
					return (row.SupplierLanguageCode || '').toUpperCase();
				},
			},
			{
				field: 'SupplierUserName',
				header: 'supplier-upload-step3.SupplierRecordsSupplierUserName',
				render: (row: SupplierRecordValidationViewModel) => {
					return html`<div>
						<p class="text-truncate max-100">${row.SupplierUserName || ''}</p>
						<p class="text-truncate max-100">${row.SupplierUserEmail || ''}</p>
					</div>`;
				},
			},
			{
				field: 'ContractNumber',
				header: 'supplier-upload-step3.SupplierRecordsConfirmingContract',
				render: (row: SupplierRecordValidationViewModel) => row.ContractNumber || '',
			},
			{
				field: 'BankCountry',
				header: 'supplier-upload-step3.SupplierRecordsSupplierBankCountryCode',
				render: (row: SupplierRecordValidationViewModel) => row.BankCountry || '',
			},
			{
				field: 'SupplierIban',
				header: 'supplier-upload-step3.SupplierRecordsSupplierIbanSwift',
				render: (row: SupplierRecordValidationViewModel) => {
					return html`<div>
						<p class="text-truncate max-100">${row.SupplierIban || ''}</p>
						<div>${row.SupplierSwift || ''}</div>
					</div>`;
				},
			},
			{
				field: 'BankName',
				header: 'supplier-upload-step3.SupplierRecordsSupplierBankNameAddress',
				render: (row: SupplierRecordValidationViewModel) => {
					return html`<div>
						<p class="text-truncate max-200">${row.BankName || ''}</p>
						<p class="text-truncate max-200">${row.BankAddress || ''}</p>
					</div>`;
				},
			},
			{
				field: 'ActivePaymentRequest',
				header: 'supplier-upload-step3.SupplierRecordsActivePaymentRequest',
				render: (row: SupplierRecordValidationViewModel) => {
					const value = (row.ActivePaymentRequest || '').toUpperCase();
					return this.translateService.translate(value, 'list-uploadedSupplierYesNo');
				},
			},
			{
				field: 'ActiveAutomaticFundingRequest',
				header: 'supplier-upload-step3.SupplierRecordsActiveAutomaticFundingRequest',
				condition: () => this.showColumnActiveAutomaticFundingRequest,
				render: (row: SupplierRecordValidationViewModel) => {
					const value = (row.ActiveAutomaticFundingRequest || '').toUpperCase();
					return this.translateService.translate(value, 'list-uploadedSupplierYesNo');
				},
			},
			{
				type: 'actions',
				icon: 'fa-solid fa-chevron-down',
				isExpand: true,
				showActions: (row: SupplierRecordValidationViewModel) => row.ValidationErrors?.length > 0,
			},
		];
	}
}
